var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "totals-statistics flex-column mb-2" }, [
    _c(
      "div",
      { staticClass: "d-flex" },
      [
        _c("div", { staticClass: "d-flex p-0 align-items-start col-2" }, [
          _c("span", { staticClass: "statistics-heading" }, [
            _vm._v(
              "\n        Statistics for " +
                _vm._s(_vm.meta.total) +
                " jobs\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _vm._l(_vm.statisticNames, function(statistic) {
          return _c(
            "div",
            { key: statistic, staticClass: "statistic-name col-1 p-0" },
            [_vm._v("\n      " + _vm._s(statistic) + "\n    ")]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "category-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.sums.time) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.sums.cash_payment) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.sums.total_credit) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.sums.total_price) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.sums.deposit) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.sums.carrier_total) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.sums.cluster_total) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.sums.balance) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category-value col-1 p-0" }),
      _vm._v(" "),
      _c("div", { staticClass: "category-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.sums.card_tips) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex mb-1" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "avg-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.averages.time) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "avg-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.averages.cash_payment) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "avg-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.averages.total_credit) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "avg-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.averages.total_price) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "avg-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.averages.deposit) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "avg-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.averages.carrier_total) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "avg-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.averages.cluster_total) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "avg-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.averages.balance) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "avg-value col-1 p-0" }),
      _vm._v(" "),
      _c("div", { staticClass: "avg-value col-1 p-0" }, [
        _vm._v("\n      " + _vm._s(_vm.averages.card_tips) + "\n    ")
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-2 p-0 d-flex justify-content-end category-value" },
      [
        _c("div", { staticClass: "col-7" }, [_c("span")]),
        _vm._v(" "),
        _c("div", { staticClass: "col-5 text-left" }, [
          _vm._v("\n        Totals\n      ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-2 p-0 d-flex justify-content-end category-value" },
      [
        _c("div", { staticClass: "col-7" }, [_c("span")]),
        _vm._v(" "),
        _c("div", { staticClass: "col-5 text-left" }, [
          _vm._v("\n        Averages\n      ")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-704151b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-704151b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/TotalsStatistics.vue
// module id = null
// module chunks = 